import { render, staticRenderFns } from "./StaffAssign.vue?vue&type=template&id=069f76bf&"
import script from "./StaffAssign.vue?vue&type=script&lang=js&"
export * from "./StaffAssign.vue?vue&type=script&lang=js&"
import style0 from "./StaffAssign.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports